// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"88c718d252da622c","6319":"082da28bba3e9056","6964":"98c144e8f1011c5d"}[chunkId] + ".css";
};